/** @jsx jsx */
import { jsx } from '@compiled/react';

import PinIcon from '@atlaskit/icon/core/pin';
import { Inline } from '@atlaskit/primitives/compiled';
import { useCommentContext } from './CommentContextProvider.tsx';

const CommentPinIndicator = () => {
	const { isPinned } = useCommentContext();

	if (!isPinned) {
		return null;
	}

	return (
		<Inline
			alignBlock="center"
			space="space.050"
			as="span"
			testId="issue-comment-base.ui.comment.custom-comment.pin-indicator"
		>
			<PinIcon color="currentColor" label="" size="medium" />
		</Inline>
	);
};
export default CommentPinIndicator;
